import React from 'react';
import { READING, R3DSPANISH, R3D, ESPANOL } from '../../constants/applications';

export const TRCAppContext = React.createContext(R3D);
TRCAppContext.displayName = 'TRCAppContext';

export const useTRCAppContext = () => React.useContext(TRCAppContext);

export const getTRCAppForGroup = appGroup => {
    if (appGroup === READING) {
        return R3D;
    }
    if (appGroup === ESPANOL) {
        return R3DSPANISH;
    }
    return undefined;
};

export default TRCAppContext;
